export default "__VITE_ASSET__fb4e123a__"